// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"folder-open-1"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M1 3.5V20L4 10L19.5 10L19.5 6L10 6L7 3.5H1Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill1","fill":"transparent","d":"M1 20L19.5 20L22.5 10L4 10L1 20Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M1 20H19.5L22.5 10H4L1 20ZM1 20L1 3.5L7 3.5L10 6L19.5 6L19.5 10","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-folder-open-1')
export default class FolderOpen1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-open-1',
    }
  }
}
